import { render, staticRenderFns } from "./MyCertificate.vue?vue&type=template&id=0e973d40&scoped=true&"
import script from "./MyCertificate.vue?vue&type=script&lang=js&"
export * from "./MyCertificate.vue?vue&type=script&lang=js&"
import style0 from "./MyCertificate.vue?vue&type=style&index=0&id=0e973d40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e973d40",
  null
  
)

export default component.exports